// @flow

import React, { Component } from 'react';
import './RankingReport.css';

export class RankingReport extends Component {
  render() {
    if (!this.props.src) {
      return (
        <div
          style={{
            textAlign: 'center',
            padding: '1rem',
          }}
        >
          <b>No data currently available at the moment!</b>
        </div>
      )
    }

    return (
      <iframe
        className="ranking-report"
        src={this.props.src}
        width="100%"
        height="700"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RankingReport/RankingReport.js